import React, { useEffect } from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useLazyGetLocationInsightsQuery } from "store/slices/locationSlice";

import LocationForecastedHeadcount from "./LocationForecastedHeadcount";
// import LocationTbhJobFunctions from "./LocationTbhJobFunctions";
import LocationSummary from "./LocationSummary";
import LocationTbhJobFunctions from "./LocationTbhJobFunctions";
import TeamForecastedHeadcount from "./TeamForecastedHeadcount";
import TeamSummary from "./TeamSummary";
import TeamTbhJobFunctions from "./TeamTbhJobFunctions";
import TopLocationsAutodesk from "./TopLocationsAutodesk";
import TopLocationsTeam from "./TopLocationsTeam";
import Question from "../../../components/Question";

const RecruitmentDetail = () => {
  const [currentParams] = useSearchParams();
  const [getLocationDetail] = useLazyGetLocationInsightsQuery();
  const { data, isLoading } = useSelector((state) => state.location);

  useEffect(() => {
    const params = Object.fromEntries(currentParams.entries());
    getLocationDetail({ params });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentParams]);

  
  if(isLoading) {
    return (
      <Box className="flex items-center justify-center w-full">
        <BeatLoader color="#5C5470" />
      </Box>
    );
  }
  
  const teamForecastedHeadcount = data?.adsk_location_metrics?.find((item) => item.metric_name === "tbh_forecasted_headcount");
  const locationForecastedHeadcount = data?.metrics?.find((item) => item.metric_name === "tbh_forecasted_headcount");
  const teamTbhJobFunctions = data?.adsk_location_metrics?.find((item) => item.metric_name === "tbh_job_function_distribution");
  const locationTbhJobFunctions = data?.metrics?.find((item) => item.metric_name === "tbh_job_function_distribution");
  const locationTbhReqSummary = data?.metrics?.find((item) => item.metric_name === "tbh_req_summary");
  const teamTbhReqSummary = data?.adsk_location_metrics?.find((item) => item.metric_name === "tbh_req_summary");
  const topTbhLocationAutodesk = data?.metrics?.find((item) => item.metric_name === "top_tbh_locations_fy");
  const topTbhLocationTeam = data?.metrics?.find((item) => item.metric_name === "team_tbhs_all_locations");

  return (
    <Box>
      <Question text="What are the budgeted Employee headcount growth and roles at this location?" />
      <Box display="flex" mb={8} mt={2}>
        <Box height="100%">
          <InfoOutlinedIcon sx={{ mr: 1, color:"#353535", fontSize: 20 }} />
        </Box>
        <Typography variant="body1" color="#353535">
          Projected headcount numbers are derived from Anaplan's TBH data. Note that the projection numbers do not take attrition into account. <br />
          TBH (To be hired) represents roles that are intended to be filled but are not yet occupied. <br />
          The open requisitions show how many of these TBH roles have had requisitions created in Workday.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={2}>
          <TeamSummary data={teamTbhReqSummary?.value} />
        </Grid>
        <Grid item xs={5}>
          <TeamForecastedHeadcount data={teamForecastedHeadcount?.value} />
        </Grid>
        <Grid item xs={5}>
          <TeamTbhJobFunctions data={teamTbhJobFunctions?.value} />
        </Grid>
        <Grid item xs={2}>
          <LocationSummary data={locationTbhReqSummary?.value} />
        </Grid>
        <Grid item xs={5}>
          <LocationForecastedHeadcount data={locationForecastedHeadcount?.value} />
        </Grid>
        <Grid item xs={5}>
          <LocationTbhJobFunctions data={locationTbhJobFunctions?.value} />
        </Grid>
        <Grid item xs={6}>
          <TopLocationsAutodesk data={topTbhLocationAutodesk?.value} />
        </Grid>
        <Grid item xs={6}>
          <TopLocationsTeam data={topTbhLocationTeam?.value} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RecruitmentDetail;
